import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchHolidayResponderFailure,
  fetchHolidayResponderSuccess,
} from "../slices/features/holidayResponder";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* getHolidaySaga(action: any) {
  const { payload } = action;
  const { id } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);
    const response: AxiosResponse<any> = yield call(
      appservice.getHolidayResponder,
      baseUrl,
      id
    );
    yield put(fetchHolidayResponderSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess();
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchHolidayResponderFailure({ statusCode, statusText }));
  }
}

export function* watchGetHolidayResponder() {
  yield takeLatest(RequestTypes.GET_HOLIDAY_AUTORESPONDER, getHolidaySaga);
}
